export type OffsetPosition = {x?: number; y?: number;};

export type OffsetPositionByOrientation = {
    landscape?: OffsetPosition;
    portrait?: OffsetPosition;
};

export type OffsetPositionByPlatform = {
    desktop?: OffsetPosition;
    mobile?: OffsetPosition | OffsetPositionByOrientation;
};